/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SortExpression } from './sort-expression';
import { WorkerSources } from './worker-sources';


export interface SearchWorkersRequest { 
    skip?: number;
    take?: number;
    includeTotalCount?: boolean | null;
    sortExpressions?: Array<SortExpression> | null;
    keyword?: string | null;
    poolIds?: Array<string> | null;
    coinIds?: Array<number> | null;
    statusIds?: Array<number> | null;
    source?: WorkerSources;
    sources?: Array<WorkerSources> | null;
}



